import { render, staticRenderFns } from "./TariffElement.vue?vue&type=template&id=98321464&"
import script from "./TariffElement.vue?vue&type=script&lang=ts&"
export * from "./TariffElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports